import { render, staticRenderFns } from "./previewMaterialModal.vue?vue&type=template&id=a1956384&scoped=true"
import script from "./previewMaterialModal.vue?vue&type=script&lang=js"
export * from "./previewMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./previewMaterialModal.vue?vue&type=style&index=0&id=a1956384&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1956384",
  null
  
)

export default component.exports